export enum KAHUN_PLATFORM {
  UNKNOWN = "",
  AGENT = "Agent",
  P1st = "Patient",
  ClinicManage = "Standalone clinic",
  Extension = "Chrome extension",
  RagChat = "RagChat",
  Extract = "Extract",
}
export enum LOGIN_STAGE {
  Login,
  Signup,
  ForgotPassword,
  VerifyEmail,
}
export const LOGIN_STAGE_TITLES = {
  [LOGIN_STAGE.Login]: "Login",
  [LOGIN_STAGE.Signup]: "Sign Up",
  [LOGIN_STAGE.ForgotPassword]: "Forgot Password",
  [LOGIN_STAGE.VerifyEmail]: "Verifying your Email",
};
export const TERMS_OF_USE_URL = "https://kahun.com/terms-of-service/";
export const PRIVACY_POLICY_URL = "https://kahun.com/privacy-policy/";
export const COOKIE_POLICY_URL = "https://www.kahun.com/cookie-settings/";
export const VERIFY_EMAIL_URL = "verify";
